import { getScreenId } from './params.js'

export async function fetchScreenData() {
  const screenId = getScreenId()
  const response = await fetch(`/screen/data?screen_id=${screenId}`)
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }
  let data = await response.json()
  return data.data || data
}

export async function fetchVideoGatewayEvents() {
  const screenId = getScreenId()
  const response = await fetch(`/screen/video_gateway_events?screen_id=${screenId}&limit=4`)
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }
  const data = await response.json()
  return data.data || data
}

export async function setDishRating(id, good, bad) {
  const response = await fetch(`/screen/set_dish_key_rating`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, good, bad })
  })
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }
  return response.json()
}
